module.exports = __webpack_public_path__ + "static/media/bff9.5871a955.png";